import React, { Component } from 'react';

import {
    Link
} from 'react-router-dom';

class LoadingScreen extends Component {
    render() {
        return (
            <React.Fragment>
            <div className="container" style={{height: window.innerHeight + "px"}}>
                    <div className="col-12 loading-content" style={{
                        backgroundImage: `url(${"/cashier/shop/static/assets/images/loading-logo.png"})`,
                        backgroundSize: "100% 100%",
                        height: "95px",
                        width: "95px",
                    }}>
                    </div>
            </div>
            </React.Fragment>
        );
    }
}

export default LoadingScreen;
